import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import icon from 'flarum/common/helpers/icon';
import PermissionDropdown from './PermissionDropdown';

const translationPrefix = 'kilowhat-formulaire.forum.global-settings.';

interface GlobalSettingsAttrs {
    type: string
}

export default class GlobalSettings implements ClassComponent<GlobalSettingsAttrs> {
    view(vnode: Vnode<GlobalSettingsAttrs, this>) {
        // [0]: permission name
        // [1]: translation key
        // [2]: allow guest
        let globalPermissions: [string, string, boolean][] = [
            ['formulaire.fill', 'fill', true],
        ];

        switch (vnode.attrs.type) {
            case 'discussion':
                globalPermissions = [
                    ['discussion.seeOwnFormulaire', 'seeOwnDiscussion', false],
                    ['discussion.seeAnyFormulaire', 'seeAnyDiscussion', true],
                    ['discussion.editOwnFormulaire', 'editOwnDiscussion', false],
                    ['discussion.editAnyFormulaire', 'editAnyDiscussion', false],
                ];
                break;
            case 'user':
                globalPermissions = [
                    ['formulaire.seeOwnUser', 'seeOwnUser', true],
                    ['formulaire.seeAnyUser', 'seeAnyUser', true],
                    ['formulaire.editOwnUser', 'editOwnUser', true],
                    ['formulaire.editAnyUser', 'editAnyUser', false],
                ];
                break;
        }

        const hidden = localStorage.getItem('formulaireHideGlobalSettings') === 'true';

        const isAdmin = !!app.forum.attribute('adminUrl');

        return m('.FormulaireGlobalSettings', [
            m('h3', {
                onclick() {
                    if (hidden) {
                        localStorage.removeItem('formulaireHideGlobalSettings');
                    } else {
                        localStorage.setItem('formulaireHideGlobalSettings', 'true');
                    }
                },
            }, [
                app.translator.trans(translationPrefix + 'title'),
                ' ',
                icon('fas fa-chevron-' + (hidden ? 'down' : 'up')),
                isAdmin ? null : [
                    ' ',
                    m('em', app.translator.trans(translationPrefix + 'admin-only')),
                ],
            ]),
            hidden ? null : globalPermissions.map(permission => m('.Form-group.FormulairePermissionFormGroup', [
                m('label', app.translator.trans(translationPrefix + 'permissions.' + permission[1])),
                PermissionDropdown.component({
                    groupIds: app.forum.attribute<any>('formulaireGlobalPermissions')[permission[0]],
                    onchange: (groupIds: string[] | null) => {
                        app.forum.attribute<any>('formulaireGlobalPermissions')[permission[0]] = groupIds;

                        app.request({
                            method: 'POST',
                            url: app.forum.attribute('apiUrl') + '/permission',
                            body: {
                                permission: permission[0],
                                groupIds,
                            },
                        });
                    },
                    disabled: !isAdmin,
                    allowGuest: permission[2],
                    guestMeansDisabled: permission[2] && permission[0].indexOf('Own') !== -1, // Will match the 2 user "own" permissions
                    disallowInherit: true,
                }),
            ])),
        ]);
    }
}
